import React, { Fragment } from "react";

import img13 from "../../../images/service/Cardano Blockchain Development/1.png";
import img14 from "../../../images/service/Cardano Blockchain Development/2.png";
import img15 from "../../../images/service/Cardano Blockchain Development/3.png";
// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Cardano dApp Development",
    content:
      "Build secure and scalable decentralized applications on Cardano using a research-driven blockchain architecture.",
  },
  {
    icon: sIcon2,
    title: "Smart Contract Development (Plutus)",
    content:
      "Develop robust Cardano smart contracts using Plutus with a strong focus on security and correctness.",
  },
  {
    icon: sIcon3,
    title: "Token & NFT Development",
    content:
      "Launch native Cardano tokens and NFT platforms with low fees and high reliability.",
  },
];

const benefits = [
  {
    title: "High Security & Reliability",
    description:
      "Cardano’s peer-reviewed design ensures strong security and predictable behavior.",
    icon: sIcon1,
  },
  {
    title: "Low Transaction Costs",
    description:
      "Native asset support enables efficient transactions without complex smart contracts.",
    icon: sIcon2,
  },
  {
    title: "Sustainable & Scalable",
    description:
      "Proof-of-Stake consensus delivers scalability with minimal energy consumption.",
    icon: sIcon3,
  },
  {
    title: "Long-Term Stability",
    description:
      "Cardano’s methodical roadmap ensures future-proof blockchain solutions.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What makes Cardano different from other blockchains?",
    a: "Cardano is built on peer-reviewed research and a layered architecture focused on security, scalability, and sustainability.",
  },
  {
    q: "Is Cardano suitable for enterprise blockchain solutions?",
    a: "Yes. Cardano’s strong security model and governance framework make it ideal for enterprise-grade applications.",
  },
  {
    q: "Do you develop smart contracts on Cardano?",
    a: "Absolutely. We build custom smart contracts using Plutus tailored to your business logic.",
  },
  {
    q: "Can Cardano support DeFi and NFT projects?",
    a: "Yes. Cardano supports DeFi protocols, NFTs, and tokenized assets with low fees and high reliability.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function CardanoBlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Cardano Blockchain Development"
        pagesub="Secure, scalable & research-driven blockchain solutions"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Build Secure dApps with{" "}
            <span className="gradient-text">Cardano Blockchain</span>
          </>
        }
        subtitle={`Leverage Cardano’s research-backed blockchain to build secure,
sustainable, and future-ready decentralized applications.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Cardano Blockchain Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Choose Cardano Blockchain?"
        image={img14}
        paragraphs={[
          "Cardano is a third-generation blockchain platform designed with a scientific approach. Its peer-reviewed protocols and layered architecture prioritize security, scalability, and sustainability.",
          "By using Proof of Stake and formal verification, Cardano enables predictable smart contracts and enterprise-ready decentralized applications.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Cardano Blockchain Development Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Limitations of Traditional Blockchain Platforms"
        image={img15}
        paragraphs={[
          "Many blockchain platforms struggle with high fees, scalability issues, and unpredictable smart contract behavior.",
          "Cardano addresses these challenges through formal methods, native asset support, and energy-efficient consensus.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Cardano Blockchain Development"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Cardano Solutions"
        subtitle="Engineered for security, scalability, and sustainability"
        features={[
          {
            icon: sIcon1,
            title: "Peer-Reviewed Protocols",
            description:
              "Scientifically validated blockchain architecture.",
          },
          {
            icon: sIcon2,
            title: "Plutus Smart Contracts",
            description:
              "Secure and formally verifiable smart contract development.",
          },
          {
            icon: sIcon3,
            title: "Native Token Support",
            description:
              "Create tokens without complex smart contracts.",
          },
          {
            icon: sIcon4,
            title: "Energy-Efficient Proof of Stake",
            description:
              "Environmentally sustainable blockchain operations.",
          },
          {
            icon: sIcon5,
            title: "Strong Governance Model",
            description:
              "On-chain governance for long-term ecosystem growth.",
          },
          {
            icon: sIcon6,
            title: "Enterprise-Ready Architecture",
            description:
              "Designed for mission-critical applications.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Expertise in Cardano and Plutus development",
          "Security-first blockchain engineering approach",
          "End-to-end Cardano solution delivery",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
